module.exports = __webpack_public_path__ + "static/media/button.16d1415f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/button.png
// module id = 2434
// module chunks = 0